import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const BackgroundVideo = ({ blok }) => (
  <div className="background-video" {...storyblokEditable(blok)} key={blok._uid}>
    <video poster={blok.fallback_image.filename} autoPlay muted loop playsInline>
      <source src={blok.source.filename} />
      <img src={blok.fallback_image.filename} alt={blok.fallback_image.alt} title="Your browser does not support the <video> tag" loading="lazy"/>
      <p>Your browser doesn't support HTML video.</p>
    </video>
  </div>
)

export default BackgroundVideo
